import { useUpdateRemoteLockConnection } from '@/api/property-keyless/remote-lock/update-remote-lock-connection'

import { RemoteLockConnectionFormValues } from './remote-lock.schema'

export const useRemoteLockSubmit = (buildingId: number) => {
  const { mutateAsync, isPending } = useUpdateRemoteLockConnection()

  const submit = (values: RemoteLockConnectionFormValues) =>
    mutateAsync({
      authorizationCode: values.authorizationCode,
      buildingId,
      config: {
        shouldAutoAssignApartmentDoorVisitor: values.shouldAutoAssignApartmentDoorVisitor,
        staffDefaults: values.staffDefaults,
        visitorDefaults: values.visitorDefaults,
      },
    })

  return { isPending, submit }
}
